<template>
  <div id="app">
    <Preloader />
    <router-view />
  </div>
</template>

<script>
if (window.navigator && navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}
</script>

<style lang="scss">
@import "@/assets/styles/main.scss";

#app {
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 100vh;
}

.button {
  background-color: $color-primary-dark;
  max-width: $grid-max-width;
  border-radius: 99999px;
  color: $txt-color-alt;
  display: inline-block;
  letter-spacing: 0.4px;
  text-align: center;
  line-height: 45px;
  font-weight: 600;
  font-size: 10px;
  width: 100%;

  @media #{$bigger-mobile} {
    font-size: 12px;
  }
}
</style>

<script>
import router from "./router";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Preloader from "@/components/Preloader.vue";

export default {
  name: "App",
  components: {
    Preloader,
  },
  beforeCreate() {
    const fpPromise = FingerprintJS.load();
    ;(async () => {
      const fp = await fpPromise;
      const result = await fp.get();
      const uInfo = result.visitorId;

      this.$store.dispatch("setUInfo", {
        uInfo,
      }).then(() => {
        const { phone_number } = this.$route.params;
        const { token } = this.$route.query;
        if (this.$route.name === "TokenInfo") {
          return;
        }
        if (phone_number && phone_number !== 'preview') {
          this.$store.dispatch('setTrainingId', {
            trainingId: phone_number
          });
        }
        if (!phone_number || (phone_number && phone_number !== 'preview' && !token)) {
          this.$router.push(`/register`)
          return;
        }
        if (token) {
          this.$store.dispatch('setToken', {
            token
          });
        }
        if (phone_number && phone_number !== 'preview') {
          this.$store.commit("initialiseStore");
        }
        this.$store.dispatch('setMode', {
          mode: phone_number && phone_number === 'preview' && phone_number || null,
        });
        this.$store.dispatch("loadAllChatLanguages", {
          url: this.$route
        });
      });
    })() 
  }
};
</script>
